import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { RequestTypeSelect } from "components/UI/RequestTypeSelect";
import {
  CarbonEmissionsCheckboxGroupShippingTypes,
  CarbonEmissionsCheckboxGroupTypeOfCalculation,
} from "constants/checkboxGroupData.constants";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const CarbonEmissionsApi = () => {
  return (
    <>
      <FormFieldControlled
        rules={VALIDATION_SCHEMA.toolInfo.required}
        labelTitle="How many API calls are you planning to make per month?"
        fieldName={INPUT_FIELD_NAMES.apiPerMonth}
        className={styles.apiInput}
      />
      <div className={styles.wrapperSelects}>
        <RequestTypeSelect
          rules={VALIDATION_SCHEMA.toolInfo.oneValue}
          fieldName={INPUT_FIELD_NAMES.carbonEmissionsShippingTypes}
          label="Which transport types do you need data for?"
          placeholder="Select request type"
          options={CarbonEmissionsCheckboxGroupShippingTypes}
        />
        <RequestTypeSelect
          rules={VALIDATION_SCHEMA.toolInfo.oneValue}
          fieldName={INPUT_FIELD_NAMES.carbonEmissionsTypeOfCalculation}
          label="Which type of calculation will you use?"
          placeholder="Select request type"
          options={CarbonEmissionsCheckboxGroupTypeOfCalculation}
        />
      </div>
    </>
  );
};
